import React from "react";
import { Business, EventBusy, Festival, Home } from "@mui/icons-material";
import { useSelector } from "../../../app/helpers";
import { RootState } from "../../../app/rootReducer";
import { ScheduleEventContentIcon } from "../../../components/Schedule/schedule-event-content-icon.component";
import type { BookingScheduleInterface } from "../../Booking-Form/typings/booking.types";
import type { DayWorkStatus } from "../types/dashboard2-work-status.types";

type Dashboard2StatusIconProps = {
  status: DayWorkStatus;
  schedule?: BookingScheduleInterface;
  userId?: string;
  iconSize?: number | string;
};

export const Dashboard2StatusIcon: React.FC<Dashboard2StatusIconProps> = ({
  status,
  schedule,
  userId,
  iconSize = 18
}) => {
  const currentUserId = useSelector((state: RootState) => state.login.userInformation.sub);
  const resolvedUserId = userId ?? currentUserId;

  if ((status.kind === "office" || status.kind === "mobile_working") && schedule) {
    return (
      <ScheduleEventContentIcon
        schedule={schedule}
        userId={resolvedUserId}
        iconSize={iconSize}
        showConferenceVisitorContactLink={false}
      />
    );
  }

  if (status.kind === "mobile_working") {
    return <Home sx={{ fontSize: iconSize }} />;
  }
  if (status.kind === "unplanned") {
    return <EventBusy sx={{ fontSize: iconSize }} />;
  }
  if (status.kind === "public_holiday") {
    return <Festival sx={{ fontSize: iconSize }} />;
  }

  return <Business sx={{ fontSize: iconSize }} />;
};
